<div class="card">
  <div class="header">
    <div class="image-block"><img [src]="data.clientName === 'Generic Client' || data.clientName === 'Quantum Leap'?'assets/images/' + formatClientName(data.clientName) + '-logo.svg':'assets/images/' + formatClientName(data.clientName) + '-logo.png'" /></div>
    <h3>{{ data.clientName }}</h3>
  </div>
  <div class="description">
    <p>
      {{ data.clientDescription }}
    </p>
  </div>
  <div class="footer">
    <button
      motifButton
      color="secondary"
      [disabled]="data.status"
      (click)="handleViewDashboard(data.clientIdentifier, data.clientName)"
    >
      View
    </button>
  </div>
</div>
